export enum ImageResizeType {
  FIX = 'FIX',
  RESIZE = 'RESIZE',
  RESIZE_KEEP_ASPECT_RATIO = 'RESIZE_KEEP_ASPECT_RATIO',
}
